/**
 *
 */
export default function getPageRouteFromPathname() {
  var pathname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var pathArray = pathname.match(/[^/]+/g);
  return pathArray ? pathArray[pathArray.length - 1] : '';
}